export default "__VITE_PUBLIC_ASSET__1812fd8f__"